module.exports = function () {
    switch (ENV_ENDPOINT) {
        case "app":
            return {
                OUTLOOK_REDIRECT: "https://outlookplugin.orphy.com/",
                ORPHY_URL: "app.orphy.com",
                API: "api.orphy.com",
                IDSRV: "idsrv.orphy.com",
                ADDRESS_PARSER: "api.orphy.com/api/v1/AddressParser",
            };
        case "app-zeintra":
            return {
                OUTLOOK_REDIRECT: "https://outlookplugin-zeintra.orphy.com/",
                ORPHY_URL: "dev.orphy.com",
                API: "dev.api.orphy.com",
                IDSRV: "dev.idsrv.orphy.com",
                ADDRESS_PARSER: "dev.api.orphy.com/api/v1/AddressParser",
            };
        case "app-girgin":
            return {
                OUTLOOK_REDIRECT: "https://outlookplugin.girgin.ch/",
                ORPHY_URL: "app.girgin.ch",
                API: "api.girgin.ch",
                IDSRV: "idsrv.girgin.ch",
                ADDRESS_PARSER: "api.girgin.ch/api/v1/AddressParser",
            };
        case "app-crmaddon":
            return {
                OUTLOOK_REDIRECT: "https://outlookplugin.dascrm.de/",
                ORPHY_URL: "app.dascrm.de",
                API: "api.dascrm.de",
                IDSRV: "idsrv.dascrm.de",
                ADDRESS_PARSER: "api.dascrm.de/api/v1/AddressParser"
            };
        case "test":
            return {
                OUTLOOK_REDIRECT: "https://outlookplugintest.orphy.com/",
                ORPHY_URL: "app.orphy.com",
                API: "api.orphy.com",
                IDSRV: "idsrv.orphy.com",
                ADDRESS_PARSER: "api.orphy.com/api/v1/AddressParser"
            };
        case "local":
            return {
                OUTLOOK_REDIRECT: "https://localhost:3000/",
                ORPHY_URL: "80-niggi.cluyo.ch",
                API: "80-niggi.cluyo.ch/orphyapi",
                IDSRV: "dev.idsrv.orphy.com",
                ADDRESS_PARSER: "80-niggi.cluyo.ch/orphyapi/api/v1/AddressParser",
            };
        case "local-app":
            return {
                OUTLOOK_REDIRECT: "https://localhost:3000/",
                ORPHY_URL: "5130-cyril.cluyo.ch",
                API: "5131-cyril.cluyo.ch",
                IDSRV: "dev.idsrv.orphy.com",
                ADDRESS_PARSER: "5131-cyril.cluyo.ch/api/v1/AddressParser"
            };
        case "local-dev":
            return {
                OUTLOOK_REDIRECT: "https://localhost:3000/",
                ORPHY_URL: "dev.orphy.com",
                API: "dev.api.orphy.com",
                IDSRV: "dev.idsrv.orphy.com",
                ADDRESS_PARSER: "dev.api.orphy.com/api/v1/AddressParser"
            };
    }
};
